export const drugAndAlcoholClearinghouseConsentForLimitedQueries = (name?: string, date?: string): any => {
  return [
    { text: 'Drug & Alcohol Clearinghouse Consent for limited Queries', style: 'h1' },
    {
      text: [
        { text: 'NOTICE TO DRIVER: ', bold: true, margin: [10, 0, 0, 0] },
        'The Commercial Driver’s License (CDL) Drug & Alcohol Clearinghouse is a federal database containing information about CDL drivers who have violated the Federal Motor Carrier Safety Administration’s (FMCSA’s) drug or alcohol regulations in 49 CFR Part 382. Whether you have committed such a violation or not, each motor carrier for whom you drive is required to check whether the Clearinghouse has any information about you, both at the time of hire and annually. When conducting an annual inquiry, the motor carrier has the option to request a “limited” report that only indicates whether the Clearinghouse has any information about you. Before a motor carrier may request a limited report, they must have your written authorization, per §382.701(b). This authorization may be valid for more than one year. If a limited query ever reveals that the Clearinghouse has information about you, you will be required to log in to the Clearinghouse website within 24 hours to grant electronic'
      ],
      style: 'p',
    },
    {
      text: [
        { text: 'NOTICE TO MOTOR CARRIER: ', bold: true, margin: [10, 0, 0, 0] },
        'This consent form authorizes you to run a “limited query” to check whether the Clearinghouse has information about the driver identified below. If it does, then you must obtain a full Clearinghouse record within 24 hours, per §382.701(b). This consent form must be retained until 3 years after the date of the last limited query you perform for this driver, based on the authorization below.',
      ],
      style: 'p',
    },
    { text: 'AUTHORIZATION', bold: true, alignment: 'center', margin: [0, 0, 0, 10] },
    {
      text: [
        'I',
        { text: ` ${name} `, bold: true },
        'hereby authorize ',
        { text: 'Sierra Expediting Inc.', bold: true, decoration: 'underline' },
        ' to conduct limited annual queries of the FMCSA’s Drug & Alcohol Clearinghouse, to determine if a Clearinghouse record exists for me. This consent is valid from the date shown below until my employment with the above-named motor carrier ceases or until I am no longer subject to the drug and alcohol testing rules in 49 CFR Part 382 for the above-named motor carrier.'
      ],
      style: 'p', // optional, for your paragraph style
    },
    {
      text: 'I understand that if any limited query reveals that the Clearinghouse contains information about me, I must grant electronic consent within 24 hours, via the Clearinghouse website, for the motor carrier to obtain my full Clearinghouse record. Refusal to provide such consent will result in my removal from safety sensitive duties.', style: 'p',
    },
    {
      canvas: [
        // Signature line
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Date line
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: "Driver's Signature", style: 'label', margin: [0, -2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};